import { render, staticRenderFns } from "./OrganizationInspectionEdit.vue?vue&type=template&id=4c751d6b&"
import script from "./OrganizationInspectionEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationInspectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports